import { Outlet } from 'react-router-dom'

import NavSidebar from 'components/NavSidebar'

const MainLayout = () => {
  return (
    <div className='font-nunito flex bg-greenPrimary'>
      <div className='fixed top-0 left-0 h-screen w-24 z-30 bg-greenPrimary'>
        <NavSidebar />
      </div>
      {/* min-w-0: without it a wide table stretches main past the viewport instead of scrolling inside its own wrapper */}
      <main className='flex flex-col p-4 bg-gray-100 border-3 border-primary border-l-0 rounded-lg w-full min-w-0 ml-24 min-h-screen'>
        <Outlet />
      </main>
    </div>
  )
}

export default MainLayout
